import { Component, Vue } from "vue-property-decorator";
import { InToast } from "@innorium/common-vue--toast";
import { InProgress } from "@innorium/common-vue--progress";
import { InMenu } from "@innorium/cn-client--menu";
import { Constants } from './constants';

@Component({
    components: {
        InToast,
        InProgress,
        InMenu
    }
})
export default class App extends Vue {
    name: string = 'App';

    appVersion: string = Constants.appVersion;
}